'use client';
import React from 'react';
import Link from 'next/link';

const NotFoundPage = ({ error, reset }: any) => {
  const handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  return (
    <>
      <div className="error padding-top padding-bottom sec-bg-color2">
        <div className="container">
          <div className="error__wrapper">
            <div
              className="error__inner"
              data-aos="fade-up"
              data-aos-duration={1000}
            >
              <div className="error__thumb text-center">
                <img src="/images/others/error.png" alt="404 image" />
              </div>
              <div className="error__content text-center">
                <h3>
                  Oops! <span> {error?.message || 'page not found'}</span>
                </h3>
                <Link
                  href="/"
                  className="trk-btn trk-btn--border trk-btn--primary"
                >
                  Back to home
                </Link>

                <span
                  onClick={handleReload}
                  className="ms-2 trk-btn trk-btn--border trk-btn--primary"
                >
                  Reset
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
